import { render, staticRenderFns } from "./publicRegister.vue?vue&type=template&id=03974681&scoped=true&"
import script from "./publicRegister.vue?vue&type=script&lang=js&"
export * from "./publicRegister.vue?vue&type=script&lang=js&"
import style0 from "./publicRegister.vue?vue&type=style&index=0&id=03974681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03974681",
  null
  
)

export default component.exports